export const t = {
  'pt-br': {
    nav: {
      features: 'Recursos',
      pricing: 'Preços',
      testimonials: 'Depoimentos',
      faq: 'FAQ',
      contact: 'Contatos',
      cta: 'Quero meu Acesso',
    },
    promoBanner: {
      text: 'Oferta Limitada | Desbloqueie o LovaGO com desconto exclusivo!',
    },
    hero: {
      trial: 'Oferta válida apenas hoje',
      title: 'Extensão Lovable Ilimitado.',
      titleHighlight: 'Sem Gastar Créditos.',
      subtitle: 'Crie sistemas completos e faça deploys ilimitados sem pagar mensalidades absurdas. Desbloqueie todo o potencial do Lovable e nunca mais seja interrompido por falta de créditos.',
      cta: 'EU QUERO MEU ACESSO',
      features: ['Ativação instantânea', 'Pagamento seguro', 'Hospedagem inclusa', 'Deploys Ilimitados'],
    },
    compatibility: { title: 'Todos os navegadores suportados' },
    problem: {
      badge: 'Por que escolher o LovaGO?',
      title: 'Tudo o que você precisa para usar o Lovable de graça e ilimitado',
      p1: 'Esqueça as assinaturas caras e os limites de mensagens. A nossa extensão remove todas as restrições.',
      p2: 'Você terá acesso a recursos premium sem pagar mensalidades absurdas.',
      p3: 'Lovable ilimitado com plano acessível. Sem surpresas, sem limites.',
    },
    benefits: {
      title: 'Vantagens Exclusivas:',
      items: [
        { title: 'Lovable Unlimited', desc: 'Use ilimitado e de graça. Crie quantos projetos quiser, sem limite de créditos.' },
        { title: 'Velocidade Máxima', desc: 'Sem filas, sem espera. Suas requisições são processadas com prioridade total.' },
        { title: 'Hospedagem Inclusa', desc: 'Publique e hospede seus projetos gratuitamente sem custo extra.' },
        { title: 'Sem Taxas Ocultas', desc: 'Pagamento único pelo período escolhido. Sem surpresas e sem limites de uso.' },
      ],
    },
    extensionPreview: {
      title: 'Tudo que a extensão faz por você',
      subtitle: 'Funcionalidades que tornam o Lovable grátis, ilimitado e com hospedagem. Tudo incluso.',
      features: [
        'Bloqueio do Chat para não gastar créditos',
        'Envio de Arquivos direto no chat',
        'Envio de Áudio (sem precisar digitar)',
        'IA para Prompts automáticos',
        'Novo Projeto Grátis (ilimitado)',
        'Tirar Marca d\'Água',
      ],
      loadingMsg: 'Ativando modo infinito...',
      badge: 'Status: GRÁTIS ∞',
      monthlySavings: 'Créditos',
      monthStr: '',
      proActive: 'PRO ACTIVE',
      subDetected: 'ASSINATURA DETECTADA',
      levelPro: 'LEVEL PRO',
      monthlyFee: 'Mensalidade: $0.00',
      aiTokens: 'Tokens de IA',
      unlimited: 'ILIMITADOS',
      deploys: 'Deploys',
      activateBtn: 'Ativar Extensão',
      inactiveStatus: 'Extensão Inativa',
      inactiveDesc: 'Licença não detectada no navegador.',
      creditsLabel: 'Uso de Créditos',
      creditsLocked: 'BLOQUEADO',
      lockedTitle: 'Recursos Premium',
      lockedFeatures: ['Bypass de Pagamento', 'Upload Ilimitado', 'Tokens de IA'],
    },
    howItWorks: {
      title: 'Como Usar Lovable Grátis?',
      subtitle: 'Veja como ter Lovable unlimited em 4 passos simples.',
      stepLabel: 'Passo',
      steps: [
        { title: 'Escolha seu plano', desc: 'Selecione o plano ideal e comece a usar o Lovable de graça.' },
        { title: 'Instale a extensão', desc: 'Instale no Chrome, Firefox, Edge ou Opera em segundos.' },
        { title: 'Ative sua licença', desc: 'Ativação instantânea com sua chave de acesso.' },
        { title: 'Lovable Unlimited', desc: 'Pronto! Agora o Lovable é grátis e ilimitado.' },
      ],
    },
    pricing: {
      title: 'Lovable Grátis e Unlimited',
      subtitle: 'Desbloqueie o Lovable ilimitado. Pagamento único. Sem surpresas. Hospedagem inclusa.',
      viewing: '{count} pessoas estão vendo esta página agora',
      weekly: {
        name: '7 Dias',
        price: 'R$ 59',
        cents: ',00',
        badge: '',
        features: ['LovaGO por 7 dias', 'Prompts ilimitados', 'Todos os navegadores', 'Hospedagem inclusa', 'Deploys Ilimitados', 'Suporte via WhatsApp'],
      },
      monthly: {
        name: '30 Dias',
        price: 'R$ 119',
        cents: ',00',
        badge: 'Mais Popular',
        features: ['LovaGO por 30 dias', 'Prompts ilimitados', 'Todos os navegadores', 'Hospedagem inclusa', 'Deploys Ilimitados', 'Suporte via WhatsApp', 'Melhor custo-benefício'],
      },
      cta: 'EU QUERO MEU ACESSO',
      ctaHighlight: 'EU QUERO MEU ACESSO',
      errorMsg: 'Link de pagamento não configurado. Entre em contato com o suporte.',
    },
    testimonials: {
      title: 'Quem Usa Lovable Grátis Recomenda',
      subtitle: 'Centenas de criadores já usam o Lovable de graça e ilimitado com o LovaGO.',
      items: [
        { name: 'Roberto M.', role: 'Desenvolvedor Full-Stack', quote: '"Finalizei 3 projetos usando o Lovable de graça com o LovaGO. Antes eu ficava preso calculando créditos o tempo todo."', initials: 'RM' },
        { name: 'Camila V.', role: 'Designer UI/UX', quote: '"Agora tenho Lovable ilimitado e posso testar todas as ideias sem me preocupar com limites. Mudou meu fluxo completamente."', initials: 'CV' },
        { name: 'Thiago P.', role: 'Desenvolvedor Freelancer', quote: '"Como freelancer, o Lovable unlimited me deu vantagem competitiva. Hospedagem grátis inclusa e consigo entregar projetos maiores."', initials: 'TP' },
        { name: 'Beatriz S.', role: 'Empreendedora', quote: '"Criei o MVP da minha startup em 2 dias sem gastar nada com créditos. Surreal a velocidade que o LovaGO proporciona!"', initials: 'BS' },
        { name: 'Felipe A.', role: 'Desenvolvedor Solo', quote: '"Nunca imaginei que seria possível usar o Lovable de graça com deploys ilimitados. O LovaGO mudou completamente minha forma de trabalhar!"', initials: 'FA' },
        { name: 'Mariana L.', role: 'Product Manager', quote: '"Consigo prototipar e publicar produtos em horas. O LovaGO é indispensável para quem quer velocidade sem gastar fortunas."', initials: 'ML' },
        { name: 'Carlos H.', role: 'Estudante de TI', quote: '"Como estudante, não tinha budget para pagar Lovable. Com o LovaGO aprendo e pratico sem nenhum limite. Simplesmente incrível!"', initials: 'CH' },
        { name: 'Daniela R.', role: 'Fundadora de Startup', quote: '"Lancei meu SaaS completo usando apenas o LovaGO. Hospedagem grátis, deploys ilimitados e zero custo de créditos. Recomendo demais!"', initials: 'DR' },
        { name: 'André L.', role: 'Desenvolvedor Back-End', quote: '"Estava cético no começo, mas após ativar o LovaGO fiquei impressionado. Sem limites, sem mensalidade e com deploy incluído. Perfeito!"', initials: 'AL' },
        { name: 'Juliana F.', role: 'CEO de Agência Digital', quote: '"Minha agência economizou mais de R$2.000 por mês em créditos do Lovable. O LovaGO pagou a si mesmo em menos de 1 dia!"', initials: 'JF' },
        { name: 'Paulo R.', role: 'Desenvolvedor Mobile', quote: '"Uso o LovaGO para prototipagem rápida de apps. Sem preocupação com créditos e com hospedagem grátis para demos de clientes."', initials: 'PR' },
        { name: 'Vanessa O.', role: 'Desenvolvedora Front-End', quote: '"Finalmente consigo experimentar livremente no Lovable sem medo de acabar os créditos no meio de um projeto importante!"', initials: 'VO' },
        { name: 'Rodrigo B.', role: 'Arquiteto de Software', quote: '"O LovaGO é a solução que eu precisava. Equipe inteira usando Lovable ilimitado com um único pagamento. Custo-benefício absurdo!"', initials: 'RB' },
        { name: 'Fernanda K.', role: 'Tech Lead', quote: '"Implementei o LovaGO no meu time de 5 pessoas. Produtividade triplicou e o custo caiu drasticamente. Recomendo sem hesitar!"', initials: 'FK' },
        { name: 'Gustavo N.', role: 'Desenvolvedor SaaS', quote: '"Lancei 2 produtos em 30 dias usando Lovable com LovaGO. Sem limites de crédito e deploy automático. Mudou meu negócio completamente."', initials: 'GN' },
        { name: 'Letícia M.', role: 'UX Engineer', quote: '"O carrossel de possibilidades que o LovaGO abre é incrível. Crio, testo, publico e itero sem nenhuma barreira de créditos ou custos extras."', initials: 'LM' },
      ],
    },
    successBanner: {
      successTitle: 'Pagamento confirmado! 🎉',
      successMsg: 'Seu acesso foi ativado. Verifique seu e-mail para as instruções.',
      canceledTitle: 'Pagamento cancelado',
      canceledMsg: 'Nenhuma cobrança foi realizada. Tente novamente quando quiser.',
    },
    thankYou: {
      confirmed: 'PAGAMENTO CONFIRMADO',
      title: 'Acesso',
      titleHighlight: 'Ativado!',
      subtitle: 'Seu pagamento foi confirmado com sucesso. Verifique seu e-mail para receber as instruções de acesso.',
      nextStepsLabel: 'Próximos passos:',
      steps: [
        'Baixe a extensão LovaGO no seu navegador',
        'Verifique seu e-mail para receber sua chave de acesso',
        'Ative a extensão e comece a criar sem limites',
      ],
      backBtn: 'Voltar ao início',
      supportBtn: 'Contatar Suporte',
    },
    salesToast: {
      action: 'comprou o plano',
      ago: 'há',
      min: 'min',
      plans: ['7 Dias', '30 Dias'],
      locations: ['São Paulo', 'Rio de Janeiro', 'Belo Horizonte', 'Curitiba', 'Brasília', 'Salvador', 'Fortaleza', 'Porto Alegre', 'Recife', 'Goiânia', 'Belém', 'Manaus', 'Campinas', 'Vitória', 'Natal'],
      names: ['Ana S.', 'João P.', 'Maria C.', 'Pedro H.', 'Lucas M.', 'Julia F.', 'Gabriel A.', 'Beatriz R.', 'Matheus T.', 'Larissa N.', 'Carlos E.', 'Fernanda O.', 'Rafael L.', 'Camila S.', 'Bruno V.', 'Letícia G.', 'Thiago M.', 'Amanda C.', 'Felipe D.', 'Jessica B.', 'Rodrigo P.', 'Mariana V.', 'Diego F.', 'Isabela M.', 'Leandro R.', 'Bruna S.', 'Marcelo A.', 'Nathalia C.', 'Guilherme P.', 'Carolina M.', 'Gustavo D.', 'Aline F.', 'Ricardo S.', 'Thais L.', 'Eduardo M.', 'Renata C.', 'Leonardo G.', 'Luana P.', 'Victor H.', 'Patrícia A.', 'Daniel S.', 'Vanessa M.', 'Alexandre R.', 'Priscila O.', 'Lucas C.', 'Bianca F.', 'Vinicius M.', 'Tatiane S.', 'Henrique L.', 'Lorena P.'],
    },
    faq: {
      title: 'Perguntas Frequentes',
      questions: [
        { q: 'Como usar o Lovable grátis?', a: 'Basta instalar a extensão LovaGO, ativar sua chave de licença adquirida e acessar o Lovable. A extensão fará todo o bypass de créditos automaticamente.' },
        { q: 'O Lovable fica grátis com o LovaGO?', a: 'Sim, durante o período do seu plano ativo, você não terá nenhum custo extra com a plataforma Lovable, acessando todos os recursos premium gratuitamente.' },
        { q: 'O LovaGO inclui hospedagem?', a: 'Sim! Além de burlar os limites de créditos e prompts, nós liberamos o recurso de deploy/hospedagem para você publicar seus projetos sem pagar nada a mais.' },
        { q: 'É seguro usar o Lovable de graça com o LovaGO?', a: '100% seguro. A extensão atua apenas no nível do navegador (front-end), alterando as requisições locais sem risco de banimento da sua conta.' },
        { q: 'Em quais navegadores funciona?', a: 'A extensão é compatível com Google Chrome, Mozilla Firefox, Microsoft Edge, Opera, Brave e qualquer outro navegador baseado em Chromium.' },
        { q: 'E se a extensão parar de funcionar?', a: 'Nossa equipe monitora as atualizações do Lovable 24/7. Caso haja alguma mudança, lançamos uma atualização automática da extensão em poucas horas.' },
        { q: 'Quanto tempo leva para ativar?', a: 'A ativação é instantânea. Após a confirmação do pagamento (PIX ou Cartão), sua chave de licença é exibida na tela e enviada para seu WhatsApp.' },
        { q: 'Posso usar em mais de um computador?', a: 'Cada licença é válida para 1 dispositivo por vez. Você pode transferir a licença desativando em um PC e ativando em outro.' },
        { q: 'Preciso cadastrar cartão de crédito na Lovable?', a: 'Não! Com a nossa extensão não é necessário cadastrar nenhum método de pagamento na Lovable. O acesso é liberado instantaneamente.' },
        { q: 'Existe limite de linhas de código geradas?', a: 'Não. O uso é totalmente ilimitado, permitindo que você crie sistemas complexos e completos sem se preocupar com tokens.' },
        { q: 'A extensão funciona no celular?', a: 'No momento, o LovaGO é compatível apenas com navegadores desktop (Windows, Mac e Linux).' },
        { q: 'Posso cancelar a qualquer momento?', a: 'Sim! O pagamento é único referente ao período escolhido (7 ou 30 dias). Não há renovação automática ou cobranças surpresas.' },
      ],
    },
    footer: {
      rights: '© 2024 LovaGO — Extensão Lovable Ilimitado | Lovable Sem Gastar Créditos. Todos os direitos reservados.',
      disclaimer: 'Suporte via WhatsApp',
    },
  },

  'en-us': {
    nav: {
      features: 'Features',
      pricing: 'Pricing',
      testimonials: 'Testimonials',
      faq: 'FAQ',
      contact: 'Contact',
      cta: 'Get My Access',
    },
    promoBanner: {
      text: 'Limited Offer | Unlock LovaGO with an exclusive discount!',
    },
    hero: {
      trial: 'Offer valid only today',
      title: 'Unlimited Lovable Extension.',
      titleHighlight: 'No Credit Cost.',
      subtitle: 'Build complete systems and make unlimited deploys without paying absurd monthly fees. Unlock Lovable\'s full potential and never get interrupted by a lack of credits again.',
      cta: 'I WANT MY ACCESS',
      features: ['Instant activation', 'Secure payment', 'Hosting included', 'Unlimited Deploys'],
    },
    compatibility: { title: 'All browsers supported' },
    problem: {
      badge: 'Why choose LovaGO?',
      title: 'Everything you need to use Lovable for free and unlimited',
      p1: 'Forget expensive subscriptions and message limits. Our extension removes all restrictions.',
      p2: 'You get premium features without paying absurd monthly fees.',
      p3: 'Unlimited Lovable with an affordable plan. No surprises, no limits.',
    },
    benefits: {
      title: 'Exclusive Benefits:',
      items: [
        { title: 'Lovable Unlimited', desc: 'Use unlimited for free. Create as many projects as you want.' },
        { title: 'Max Speed', desc: 'No queues, no waiting. Your requests are processed with top priority.' },
        { title: 'Hosting Included', desc: 'Publish and host your projects for free at no extra cost.' },
        { title: 'No Hidden Fees', desc: 'One-time payment for the chosen period. No surprises and no usage limits.' },
      ],
    },
    extensionPreview: {
      title: 'Everything the extension does for you',
      subtitle: 'Features that make Lovable free, unlimited, and hosted. All included.',
      features: [
        'Chat Blocker to save credits',
        'Direct File Uploads',
        'Audio Uploads (no typing needed)',
        'AI Prompt Enhancer',
        'Free New Projects (unlimited)',
        'Remove Watermark',
      ],
      loadingMsg: 'Activating infinite mode...',
      badge: 'Status: FREE ∞',
      monthlySavings: 'Credits',
      monthStr: '',
      proActive: 'PRO ACTIVE',
      subDetected: 'SUBSCRIPTION DETECTED',
      levelPro: 'LEVEL PRO',
      monthlyFee: 'Monthly Fee: $ 0.00',
      aiTokens: 'AI Tokens',
      unlimited: 'UNLIMITED',
      deploys: 'Deploys',
      activateBtn: 'Activate Extension',
      inactiveStatus: 'Extension Inactive',
      inactiveDesc: 'License not detected in browser.',
      creditsLabel: 'Credit Usage',
      creditsLocked: 'LOCKED',
      lockedTitle: 'Premium Features',
      lockedFeatures: ['Payment Bypass', 'Unlimited Uploads', 'AI Tokens'],
    },
    howItWorks: {
      title: 'How to use Free Lovable?',
      subtitle: 'See how to get Lovable unlimited in 4 simple steps.',
      stepLabel: 'Step',
      steps: [
        { title: 'Choose your plan', desc: 'Select the ideal plan and start using Lovable for free.' },
        { title: 'Install extension', desc: 'Install on Chrome, Firefox, Edge, or Opera in seconds.' },
        { title: 'Activate license', desc: 'Instant activation with your access key.' },
        { title: 'Lovable Unlimited', desc: 'Done! Now Lovable is free and unlimited.' },
      ],
    },
    pricing: {
      title: 'Free and Unlimited Lovable',
      subtitle: 'Unlock unlimited Lovable. One-time payment. No surprises. Hosting included.',
      viewing: '{count} people are viewing this page right now',
      weekly: {
        name: '7 Days',
        price: 'US$ 12',
        cents: '.00',
        badge: '',
        features: ['LovaGO for 7 days', 'Unlimited prompts', 'All browsers', 'Hosting included', 'Unlimited Deploys', '24/7 Support'],
      },
      monthly: {
        name: '30 Days',
        price: 'US$ 29',
        cents: '.00',
        badge: 'Most Popular',
        features: ['LovaGO for 30 days', 'Unlimited prompts', 'All browsers', 'Hosting included', 'Unlimited Deploys', '24/7 Support', 'Best Value'],
      },
      cta: 'I WANT MY ACCESS',
      ctaHighlight: 'I WANT MY ACCESS',
      errorMsg: 'Payment link not configured. Please contact support.',
    },
    testimonials: {
      title: 'Who Uses Free Lovable Recommends',
      subtitle: 'Hundreds of creators already use Lovable for free and unlimited with LovaGO.',
      items: [
        { name: 'Robert M.', role: 'Full-Stack Developer', quote: '"Finished 3 projects using free Lovable with LovaGO. Before, I was stuck calculating credits all the time."', initials: 'RM' },
        { name: 'Camila V.', role: 'UI/UX Designer', quote: '"Now I have unlimited Lovable and can test all ideas without worrying about limits. It changed my workflow."', initials: 'CV' },
        { name: 'Thiago P.', role: 'Freelance Developer', quote: '"As a freelancer, unlimited Lovable gave me a competitive edge. Free hosting included and I can deliver larger projects."', initials: 'TP' },
        { name: 'Beatriz S.', role: 'Entrepreneur', quote: '"I built my startup MVP in 2 days without spending anything on credits. The speed LovaGO provides is surreal!"', initials: 'BS' },
        { name: 'Philip A.', role: 'Solo Developer', quote: '"I never imagined it was possible to use Lovable for free with unlimited deploys. LovaGO completely changed the way I work!"', initials: 'PA' },
        { name: 'Marina L.', role: 'Product Manager', quote: '"I can prototype and publish products in hours. LovaGO is indispensable for anyone who wants speed without spending a fortune."', initials: 'ML' },
        { name: 'Charles H.', role: 'IT Student', quote: '"As a student, I had no budget for Lovable. With LovaGO I learn and practice with no limits whatsoever. Simply incredible!"', initials: 'CH' },
        { name: 'Daniela R.', role: 'Startup Founder', quote: '"I launched my complete SaaS using only LovaGO. Free hosting, unlimited deploys and zero credit costs. Highly recommended!"', initials: 'DR' },
        { name: 'Andrew L.', role: 'Back-End Developer', quote: '"I was skeptical at first, but after activating LovaGO I was blown away. No limits, no monthly fees and deploy included. Perfect!"', initials: 'AL' },
        { name: 'Julia F.', role: 'Digital Agency CEO', quote: '"My agency saved over $400/month in Lovable credits. LovaGO paid for itself in less than a day!"', initials: 'JF' },
        { name: 'Paul R.', role: 'Mobile Developer', quote: '"I use LovaGO for rapid app prototyping. No credit worries and free hosting for client demos."', initials: 'PR' },
        { name: 'Vanessa O.', role: 'Front-End Developer', quote: '"I can finally experiment freely on Lovable without fear of running out of credits mid-project!"', initials: 'VO' },
        { name: 'Roger B.', role: 'Software Architect', quote: '"LovaGO is the solution I needed. Entire team using unlimited Lovable with a single payment. Incredible value!"', initials: 'RB' },
        { name: 'Frances K.', role: 'Tech Lead', quote: '"Implemented LovaGO for my team of 5. Productivity tripled and costs dropped dramatically. Highly recommend!"', initials: 'FK' },
        { name: 'Gus N.', role: 'SaaS Developer', quote: '"Launched 2 products in 30 days using Lovable with LovaGO. No credit limits and auto deploy. It changed my business."', initials: 'GN' },
        { name: 'Laura M.', role: 'UX Engineer', quote: '"The endless possibilities LovaGO opens up are incredible. Create, test, publish and iterate with zero barriers."', initials: 'LM' },
      ],
    },
    successBanner: {
      successTitle: 'Payment confirmed! 🎉',
      successMsg: 'Your access has been activated. Check your email for instructions.',
      canceledTitle: 'Payment canceled',
      canceledMsg: 'No charge was made. Try again whenever you want.',
    },
    thankYou: {
      confirmed: 'PAYMENT CONFIRMED',
      title: 'Access',
      titleHighlight: 'Activated!',
      subtitle: 'Your payment has been successfully confirmed. Check your email for access instructions.',
      nextStepsLabel: 'Next steps:',
      steps: [
        'Download the LovaGO extension in your browser',
        'Check your email to receive your access key',
        'Activate the extension and start creating without limits',
      ],
      backBtn: 'Back to home',
      supportBtn: 'Contact Support',
    },
    salesToast: {
      action: 'bought the plan',
      ago: 'ago',
      min: 'min',
      plans: ['7 Days', '30 Days'],
      locations: ['New York', 'London', 'Toronto', 'Sydney', 'Miami', 'Los Angeles', 'Chicago', 'Berlin', 'Austin', 'Denver', 'Seattle', 'Boston', 'Houston', 'Dallas', 'Atlanta'],
      names: ['James S.', 'Mary B.', 'John M.', 'Patricia W.', 'Robert C.', 'Jennifer G.', 'Michael H.', 'Linda T.', 'William R.', 'Elizabeth D.', 'David F.', 'Barbara P.', 'Richard M.', 'Susan S.', 'Joseph H.', 'Jessica C.', 'Thomas M.', 'Sarah B.', 'Charles W.', 'Karen L.', 'Christopher G.', 'Nancy R.', 'Daniel S.', 'Lisa P.', 'Matthew T.', 'Betty M.', 'Anthony C.', 'Margaret W.', 'Mark R.', 'Sandra B.'],
    },
    faq: {
      title: 'Frequently Asked Questions',
      questions: [
        { q: 'How to use free Lovable?', a: 'Just install the LovaGO extension, activate your purchased license key, and access Lovable. The extension will handle the credit bypass automatically.' },
        { q: 'Is Lovable free with LovaGO?', a: 'Yes, during your active plan period, you will not have any extra costs with the Lovable platform, accessing all premium features for free.' },
        { q: 'Does LovaGO include hosting?', a: 'Yes! In addition to bypassing credit and prompt limits, we unlock the deploy/hosting feature so you can publish your projects without paying extra.' },
        { q: 'Is it safe to use free Lovable with LovaGO?', a: '100% safe. The extension only acts at the browser level (front-end), altering local requests without the risk of banning your account.' },
        { q: 'Which browsers does it work on?', a: 'The extension is compatible with Google Chrome, Mozilla Firefox, Microsoft Edge, Opera, Brave, and any other Chromium-based browser.' },
        { q: 'What if the extension stops working?', a: 'Our team monitors Lovable updates 24/7. If there are any changes, we release an automatic extension update within hours.' },
        { q: 'How long does it take to activate?', a: 'Activation is instant. After payment confirmation, your license key is displayed on the screen and sent to your email/phone.' },
        { q: 'Can I use it on more than one computer?', a: 'Each license is valid for 1 device at a time. You can transfer the license by deactivating it on one PC and activating it on another.' },
        { q: 'Do I need to register a credit card on Lovable?', a: 'No! With our extension, there is no need to register any payment method on Lovable. Access is granted instantly.' },
        { q: 'Is there a limit on generated lines of code?', a: 'No. Usage is completely unlimited, allowing you to create complex and complete systems without worrying about tokens.' },
        { q: 'Does the extension work on mobile?', a: 'Currently, LovaGO is only compatible with desktop browsers (Windows, Mac, and Linux).' },
        { q: 'Can I cancel anytime?', a: 'Yes! It is a one-time payment for the chosen period (7 or 30 days). There are no auto-renewals or hidden charges.' },
      ],
    },
    footer: {
      rights: '© 2024 LovaGO — Unlimited Lovable Extension | Lovable Without Spending Credits. All rights reserved.',
      disclaimer: 'Support via WhatsApp',
    },
  },

  'es-la': {
    nav: {
      features: 'Características',
      pricing: 'Precios',
      testimonials: 'Testimonios',
      faq: 'FAQ',
      contact: 'Contactos',
      cta: 'Quiero mi Acceso',
    },
    promoBanner: {
      text: '¡Oferta Limitada | Desbloquea LovaGO con un descuento exclusivo!',
    },
    hero: {
      trial: 'Oferta válida solo hoy',
      title: 'Extensión Lovable Ilimitado.',
      titleHighlight: 'Sin Gastar Créditos.',
      subtitle: 'Crea sistemas completos y realiza deploys ilimitados sin pagar mensualidades absurdas. Desbloquea todo el potencial de Lovable y nunca más te detengas por falta de créditos.',
      cta: 'QUIERO MI ACCESO',
      features: ['Activación instantánea', 'Pago seguro', 'Hosting incluido', 'Deploys Ilimitados'],
    },
    compatibility: { title: 'Todos los navegadores compatibles' },
    problem: {
      badge: '¿Por qué elegir LovaGO?',
      title: 'Todo lo que necesitas para usar Lovable gratis e ilimitado',
      p1: 'Olvídate de suscripciones caras y límites de mensajes. Nuestra extensión elimina todas las restricciones.',
      p2: 'Obtienes funciones premium sin pagar cuotas mensuales absurdas.',
      p3: 'Lovable ilimitado con un plan accesible. Sin sorpresas, sin límites.',
    },
    benefits: {
      title: 'Beneficios Exclusivos:',
      items: [
        { title: 'Lovable Unlimited', desc: 'Uso ilimitado y gratis. Crea todos los proyectos que quieras.' },
        { title: 'Velocidad Máxima', desc: 'Sin filas, sin espera. Tus peticiones se procesan con máxima prioridad.' },
        { title: 'Hosting Incluido', desc: 'Publica y aloja tus proyectos gratis sin costo extra.' },
        { title: 'Sin Cargos Ocultos', desc: 'Pago único por el período elegido. Sin sorpresas y sin límites de uso.' },
      ],
    },
    extensionPreview: {
      title: 'Todo lo que la extensión hace por ti',
      subtitle: 'Funciones que hacen a Lovable gratis, ilimitado y con hosting. Todo incluido.',
      features: [
        'Bloqueo de Chat para no gastar créditos',
        'Envío de Archivos directo',
        'Envío de Audio (sin escribir)',
        'IA para Prompts automáticos',
        'Nuevo Proyecto Gratis (ilimitado)',
        'Quitar Marca de Agua',
      ],
      loadingMsg: 'Activando modo infinito...',
      badge: 'Estado: GRATIS ∞',
      monthlySavings: 'Créditos',
      monthStr: '',
      proActive: 'PRO ACTIVE',
      subDetected: 'SUSCRIPCIÓN DETECTADA',
      levelPro: 'LEVEL PRO',
      monthlyFee: 'Mensualidad: $ 0.00',
      aiTokens: 'Tokens de IA',
      unlimited: 'ILIMITADOS',
      deploys: 'Deploys',
      activateBtn: 'Activar Extensión',
      inactiveStatus: 'Extensión Inactiva',
      inactiveDesc: 'Licencia no detectada en el navegador.',
      creditsLabel: 'Uso de Créditos',
      creditsLocked: 'BLOQUEADO',
      lockedTitle: 'Funciones Premium',
      lockedFeatures: ['Bypass de Pago', 'Uploads Ilimitados', 'Tokens de IA'],
    },
    howItWorks: {
      title: '¿Cómo Usar Lovable Gratis?',
      subtitle: 'Mira cómo tener Lovable unlimited en 4 simples pasos.',
      stepLabel: 'Paso',
      steps: [
        { title: 'Elige tu plan', desc: 'Selecciona el plan ideal y comienza a usar Lovable gratis.' },
        { title: 'Instala la extensión', desc: 'Instálalo en Chrome, Firefox, Edge u Opera en segundos.' },
        { title: 'Activa tu licencia', desc: 'Activación instantánea con tu clave de acceso.' },
        { title: 'Lovable Unlimited', desc: '¡Listo! Ahora Lovable es gratis e ilimitado.' },
      ],
    },
    pricing: {
      title: 'Lovable Gratis y Unlimited',
      subtitle: 'Desbloquea Lovable ilimitado. Pago único. Sin sorpresas. Hosting incluido.',
      viewing: '{count} personas están viendo esta página ahora',
      weekly: {
        name: '7 Días',
        price: 'US$ 12',
        cents: '.00',
        badge: '',
        features: ['LovaGO por 7 días', 'Prompts ilimitados', 'Todos los navegadores', 'Hosting incluido', 'Deploys Ilimitados', 'Soporte 24/7'],
      },
      monthly: {
        name: '30 Días',
        price: 'US$ 29',
        cents: '.00',
        badge: 'Más Popular',
        features: ['LovaGO por 30 días', 'Prompts ilimitados', 'Todos los navegadores', 'Hosting incluido', 'Deploys Ilimitados', 'Soporte 24/7', 'Mejor valor'],
      },
      cta: 'QUIERO MI ACCESO',
      ctaHighlight: 'QUIERO MI ACCESO',
      errorMsg: 'Enlace de pago no configurado. Contacte al soporte.',
    },
    testimonials: {
      title: 'Quien Usa Lovable Gratis Recomienda',
      subtitle: 'Cientos de creadores ya usan Lovable gratis e ilimitado con LovaGO.',
      items: [
        { name: 'Roberto M.', role: 'Desarrollador Full-Stack', quote: '"Terminé 3 proyectos usando Lovable gratis con LovaGO. Antes estaba atascado calculando créditos todo el tiempo."', initials: 'RM' },
        { name: 'Camila V.', role: 'Diseñadora UI/UX', quote: '"Ahora tengo Lovable ilimitado y puedo probar todas las ideas sin preocuparme por los límites."', initials: 'CV' },
        { name: 'Thiago P.', role: 'Desarrollador Freelance', quote: '"Como freelancer, Lovable unlimited me dio una ventaja competitiva. Hosting gratis incluido y entrego proyectos más grandes."', initials: 'TP' },
        { name: 'Beatriz S.', role: 'Emprendedora', quote: '"Creé el MVP de mi startup en 2 días sin gastar nada en créditos. ¡La velocidad que LovaGO proporciona es surrealista!"', initials: 'BS' },
        { name: 'Felipe A.', role: 'Desarrollador Solo', quote: '"Nunca imaginé que sería posible usar Lovable gratis con deploys ilimitados. ¡LovaGO cambió completamente mi forma de trabajar!"', initials: 'FA' },
        { name: 'Mariana L.', role: 'Product Manager', quote: '"Puedo prototipar y publicar productos en horas. LovaGO es indispensable para quien quiere velocidad sin gastar fortunas."', initials: 'ML' },
        { name: 'Carlos H.', role: 'Estudiante de TI', quote: '"Como estudiante, no tenía presupuesto para Lovable. Con LovaGO aprendo y practico sin ningún límite. ¡Simplemente increíble!"', initials: 'CH' },
        { name: 'Daniela R.', role: 'Fundadora de Startup', quote: '"Lancé mi SaaS completo usando solo LovaGO. Hosting gratis, deploys ilimitados y cero costo de créditos. ¡Lo recomiendo!"', initials: 'DR' },
        { name: 'Andrés L.', role: 'Desarrollador Back-End', quote: '"Estaba escéptico al principio, pero tras activar LovaGO quedé impresionado. Sin límites, sin mensualidad y con deploy incluido."', initials: 'AL' },
        { name: 'Julia F.', role: 'CEO de Agencia Digital', quote: '"Mi agencia ahorró más de $400/mes en créditos de Lovable. ¡LovaGO se pagó solo en menos de un día!"', initials: 'JF' },
        { name: 'Pablo R.', role: 'Desarrollador Mobile', quote: '"Uso LovaGO para prototipado rápido de apps. Sin preocupación por créditos y hosting gratis para demos de clientes."', initials: 'PR' },
        { name: 'Vanessa O.', role: 'Desarrolladora Front-End', quote: '"¡Por fin puedo experimentar libremente en Lovable sin miedo a quedarme sin créditos en medio de un proyecto!"', initials: 'VO' },
        { name: 'Rodrigo B.', role: 'Arquitecto de Software', quote: '"LovaGO es la solución que necesitaba. Todo el equipo usando Lovable ilimitado con un solo pago. ¡Valor increíble!"', initials: 'RB' },
        { name: 'Fernanda K.', role: 'Tech Lead', quote: '"Implementé LovaGO en mi equipo de 5 personas. La productividad se triplicó y los costos bajaron drásticamente."', initials: 'FK' },
        { name: 'Gustavo N.', role: 'Desarrollador SaaS', quote: '"Lancé 2 productos en 30 días usando Lovable con LovaGO. Sin límites de crédito y deploy automático. Cambió mi negocio."', initials: 'GN' },
        { name: 'Leticia M.', role: 'UX Engineer', quote: '"Las posibilidades infinitas que abre LovaGO son increíbles. Creo, pruebo, publico e itero sin ninguna barrera."', initials: 'LM' },
      ],
    },
    successBanner: {
      successTitle: '¡Pago confirmado! 🎉',
      successMsg: 'Tu acceso ha sido activado. Revisa tu correo para las instrucciones.',
      canceledTitle: 'Pago cancelado',
      canceledMsg: 'No se realizó ningún cargo. Intenta de nuevo cuando quieras.',
    },
    thankYou: {
      confirmed: 'PAGO CONFIRMADO',
      title: '¡Acceso',
      titleHighlight: 'Activado!',
      subtitle: 'Tu pago fue confirmado con éxito. Revisa tu correo para recibir las instrucciones de acceso.',
      nextStepsLabel: 'Próximos pasos:',
      steps: [
        'Descarga la extensión LovaGO en tu navegador',
        'Revisa tu correo para recibir tu clave de acceso',
        'Activa la extensión y empieza a crear sin límites',
      ],
      backBtn: 'Volver al inicio',
      supportBtn: 'Contactar Soporte',
    },
    salesToast: {
      action: 'compró el plan',
      ago: 'hace',
      min: 'min',
      plans: ['7 Días', '30 Días'],
      locations: ['Madrid', 'Ciudad de México', 'Bogotá', 'Buenos Aires', 'Lima', 'Santiago', 'Quito', 'Caracas', 'Montevideo', 'La Paz', 'San José', 'Panamá', 'Asunción', 'San Juan', 'Guatemala'],
      names: ['Santiago M.', 'Sofía R.', 'Mateo C.', 'Valentina G.', 'Sebastián P.', 'Isabella F.', 'Alejandro M.', 'Camila L.', 'Diego S.', 'Mariana P.', 'Nicolás M.', 'Luciana C.', 'Daniel R.', 'Valeria M.', 'Martín G.', 'Victoria P.', 'Joaquín S.', 'Martina M.', 'Tomás C.', 'María R.'],
    },
    faq: {
      title: 'Preguntas Frecuentes',
      questions: [
        { q: '¿Cómo usar Lovable gratis?', a: 'Solo instala la extensión LovaGO, activa tu clave de licencia adquirida y accede a Lovable. La extensión hará todo el bypass automáticamente.' },
        { q: '¿Lovable es gratis con LovaGO?', a: 'Sí, durante el período de tu plan activo, no tendrás ningún costo extra con la plataforma Lovable.' },
        { q: '¿LovaGO incluye hosting?', a: '¡Sí! Además de evadir los límites de créditos, desbloqueamos la función de deploy/hosting para que publiques sin pagar de más.' },
        { q: '¿Es seguro usar Lovable gratis con LovaGO?', a: '100% seguro. La extensión actúa solo a nivel del navegador (front-end), alterando las peticiones locales sin riesgo de baneo.' },
        { q: '¿En qué navegadores funciona?', a: 'La extensión es compatible con Google Chrome, Mozilla Firefox, Microsoft Edge, Opera, Brave y cualquier navegador Chromium.' },
        { q: '¿Y si la extensión deja de funcionar?', a: 'Nuestro equipo monitorea las actualizaciones de Lovable 24/7. Lanzamos una actualización automática en pocas horas si algo cambia.' },
        { q: '¿Cuánto tiempo tarda en activarse?', a: 'La activación es instantánea. Tras confirmar el pago, tu clave de licencia se muestra en pantalla y se envía a tu correo/WhatsApp.' },
        { q: '¿Puedo usarlo en más de una computadora?', a: 'Cada licencia es válida para 1 dispositivo a la vez. Puedes transferirla desactivándola en una PC y activándola en otra.' },
        { q: '¿Necesito registrar una tarjeta de crédito en Lovable?', a: '¡No! Con nuestra extensión no es necesario registrar ningún método de pago en Lovable. El acceso se otorga al instante.' },
        { q: '¿Hay un límite en las líneas de código generadas?', a: 'No. El uso es totalmente ilimitado, permitiéndote crear sistemas complejos sin preocuparte por los tokens.' },
        { q: '¿La extensión funciona en el móvil?', a: 'Actualmente, LovaGO solo es compatible con navegadores de escritorio (Windows, Mac y Linux).' },
        { q: '¿Puedo cancelar en cualquier momento?', a: '¡Sí! Es un pago único por el período elegido (7 o 30 días). No hay renovaciones automáticas ni cargos ocultos.' },
      ],
    },
    footer: {
      rights: '© 2024 LovaGO — Extensión Lovable Ilimitado | Lovable Sin Gastar Créditos. Todos los derechos reservados.',
      disclaimer: 'Soporte vía WhatsApp',
    },
  },
};